import {
  DashboardEmployeeData,
  DipendentiDashboardData,
  MansioneDashboard,
  SedeDiLavoroDashboard,
} from "../../types";
import { chiaveSede } from "../certificate/pipeline";
import { chiaveMansione } from "../../utils/utils";

/*
 Le etichette con cui si mostra chi non ha l'informazione. Le passa il chiamante gia'
 tradotte: qui non si monta i18n, perche' questa resta una funzione pura.
*/
export type EtichetteRaggruppamento = {
  sedeNonIndicata: string;
  mansioneNonIndicata: string;
};

/*
 I dipendenti della dashboard raggruppati per sede di lavoro, e dentro ogni sede per mansione.

 Sede di lavoro e mansione sono testo libero dell'anagrafica: la stessa sede arriva scritta in
 modi che a schermo sembrano identici (spazi ai bordi, maiuscole diverse) e puo' mancare del
 tutto. Si usano percio' le chiavi di confronto gia' in uso altrove — `chiaveSede` per la
 pipeline degli attestati, `chiaveMansione` per i filtri dell'anagrafica — cosi' le varianti
 collassano in un solo gruppo invece di moltiplicare le righe del riquadro.

 Chi non ha sede (o mansione) non si perde: finisce in un gruppo con un'etichetta esplicita.
 Contarlo nel totale e non mostrarlo nell'elenco farebbe tornare i conti solo in apparenza,
 ed e' proprio il dipendente incompleto quello che va visto per essere sistemato.
*/
export function raggruppaPerSede(
  dipendenti: DashboardEmployeeData[],
  etichette: EtichetteRaggruppamento,
): DipendentiDashboardData {
  const sediMap = new Map<string, SedeDiLavoroDashboard>();
  const dipendentiData: DipendentiDashboardData = {
    tot: dipendenti.length,
    sedi: [],
  };

  dipendenti.forEach((dipendente) => {
    const chiave = chiaveSede(dipendente.workplace);

    let sede = sediMap.get(chiave);
    if (!sede) {
      sede = {
        nome: chiave || etichette.sedeNonIndicata,
        dipendenti: 0,
        mansioni: new Map<string, MansioneDashboard>(),
      };
      sediMap.set(chiave, sede);
      dipendentiData.sedi.push(sede);
    }

    sede.dipendenti++;

    const chiaveDellaMansione = chiaveMansione(dipendente.jobDescription);
    const mansione = sede.mansioni.get(chiaveDellaMansione);
    if (mansione) {
      mansione.dipendenti++;
    } else {
      sede.mansioni.set(chiaveDellaMansione, {
        nome: chiaveDellaMansione || etichette.mansioneNonIndicata,
        dipendenti: 1,
      });
    }
  });

  return dipendentiData;
}
